// ============================================================
// BACKEND CONFIGURATION
// Set REACT_APP_API_URL in your .env file, or update here
// after deployment.
// ============================================================
const config = {
  // Leave empty — fill in your deployed backend URL before running
  API_BASE_URL: process.env.REACT_APP_API_URL || "",
  API_KEY: process.env.REACT_APP_API_KEY || "",
};

export default config;
